module.exports = __webpack_public_path__ + "img/level_six_hover.7dc02cac.png";